import { render, staticRenderFns } from "./AlertsNavareaModal.vue?vue&type=template&id=7c51821e&scoped=true&"
import script from "./AlertsNavareaModal.vue?vue&type=script&lang=js&"
export * from "./AlertsNavareaModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertsNavareaModal.vue?vue&type=style&index=0&id=7c51821e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c51821e",
  null
  
)

export default component.exports